<template>
    <v-layout>
        <v-bottom-sheet v-model="show" :persistent="true">
            <v-card class="">
                <v-layout row wrap align-center justify-end>
                    <v-btn small icon small @click="$emit('hide')">
                        <v-icon small color="grey darken-1">fas fa-times</v-icon>
                    </v-btn>
                </v-layout>
                <v-divider></v-divider>
                <v-container>
                    <div v-if="variants.length > 0">
                        <div class="body-2">Select Variation</div >
                        <div v-for="(variant, index) in variants" :key="index" >
                            <v-layout row align-center>
                                <v-flex xs2>{{variant.name}}</v-flex>
                                <v-flex xs10 style="max-height: 100px; overflow-y: auto;">
                                    <v-btn  round
                                            small
                                            v-for="(option,index2) in variant.variant_options"
                                            :key="index2"
                                            :color="variants[index].variant_options[index2].selected ? 'secondary' : 'default'"
                                            @click="selectVariantOption(index, index2)"
                                            depressed>{{option.name}}
                                            </v-btn>
                                </v-flex>
                            </v-layout>
                            <v-divider class="my-2"></v-divider>
                        </div>
                    </div>
                    <div class="pb-3">
                        <div class="grey--text text--darken-2 body-1">Select Branch</div>
                        <v-select
                                :items="branches"
                                solo
                                hide-details
                                item-text="name"
                                return-object
                                v-model="selectedBranch"
                                class="outline-field"
                        ></v-select>
                    </div>
                    <v-divider></v-divider>
                    <v-layout row justify-start align-center>
                        <v-flex xs4>
                            <div class="grey--text text--darken-2 body-1">Quantity (Stock {{stock}})</div>
                        </v-flex>
                        <v-flex xs8>
                            <v-layout row align-center>
                                <v-btn icon depressed flat @click="adjustQuantity(-1)">-</v-btn>
                                <v-text-field flat solo hide-details heigh="50" class="text-xs-center centered-input" v-model="quantity" type="number"></v-text-field>
                                <v-btn icon depressed flat @click="adjustQuantity(1)">+</v-btn>
                            </v-layout>
                        </v-flex>
                    </v-layout>
                    <v-divider></v-divider>
                    <v-layout row justify-start align-center py-2>
                        <v-flex xs4>
                            <div class="grey--text text--darken-2 body-1">Price</div>
                        </v-flex>
                        <v-flex xs8>
                            <v-layout row align-center justify-end>
                                <h2 class="red--text">{{numberWithCommas(price)}}</h2>
                            </v-layout>
                        </v-flex>
                    </v-layout>
                    <v-divider></v-divider>
                    <v-btn block depressed color="secondary" @click="addToCart" class="mt-3 text-capitalize">
                        <v-icon>mdi-plus</v-icon>
                        <span class="mr-2">{{actionCart}}</span>
                    </v-btn>
                </v-container>
            </v-card>
        </v-bottom-sheet>
        <LoginRegisterModal
                :dialog="loginRegisterModalShow"
                :add-to-cart="true"
                :register-only="true"
                @hide="loginRegisterModalShow = false"
        ></LoginRegisterModal>
        <v-snackbar
                v-model="snackbarShow"
                :color="snackbarColor "
                right
                top
                :timeout="2000">
            {{snackbarText}}
            <v-btn
                    small
                    dark
                    flat
                    @click="snackbarShow = false">
                <v-icon>mdi-close</v-icon>
            </v-btn>
        </v-snackbar>
    </v-layout>
</template>

<script>
    import VTextField from "vuetify/lib/components/VTextField/VTextField";
    import LoginRegisterModal from "./LoginRegisterModal";
    export default {
        name: "AddToCart",
        components: {LoginRegisterModal, VTextField},
        props : {
            productId : {
                type    : String,
                required: true,
            },
            show      : Boolean,
            variations: {},
            branches  : {},
            variants  : {},
            wholeSale : {},
            actionCart: '',

        },
        data: () => ({
            snackbarShow          : false,
            snackbarColor         : '',
            snackbarText          : '',
            formData              : [],
            selectedBranch        : {},
            quantity              : 1,
            checkVariationSelected: false,
            variationSelected     : {},
            loginRegisterModalShow: false,
            branch_variation      : {},
            original_price        : 0,
            price                 : 0,
            stock                 : 0,
        }),
        watch : {
            variants: {
                handler: function (after, before) {
                    this.checkVariationSelection(after);
                    this.changePricePerQuantity();

                },
                deep: true,
            },
            selectedBranch: {
                handler: function (after, before) {
                    if (this.checkVariationSelected){
                        this.checkVariationSelection(this.variants);
                        this.changePricePerQuantity();
                    }
                },
                deep: true,
            },
            quantity : {
                handler: function (after, before) {
                        if (this.quantity <= 0){
                            this.quantity = 1;
                        }
                        this.changePricePerQuantity();

                },
                deep: true,
            }
        },
        methods : {
            changePricePerQuantity(){


                this.price =  this.original_price * this.quantity;
                for (let i = 0 ; i < this.wholeSale.length ; i++){
                    if (this.quantity>= this.wholeSale[i].quantity && this.quantity<= this.wholeSale[i].quantity_max){
                        this.price -= (this.wholeSale[i].discount * this.quantity);
                        break;
                    }
                }
            },
            getFormData(){
                axios.get(`/api/product?${this.productId}/variations`)
                    .then(response => {
                        this.formData = response.data;
                    })
                    .catch(err => {
                        this.toaster('something went wrong.', 201);
                    })
                    .finally(()=> this.loading = false);
            },
            formatVariantSelection(){
                this.variants.forEach((variant, index)=>{

                    variant.variant_options.forEach((options, index2)=> {
                        this.variants[index].variant_options[index2].selected = false;
                    });
                });
            },
            selectVariantOption(variant_index, option_index){
                this.removeSelectedVariantOption(variant_index);
                this.variants[variant_index].variant_options[option_index].name = this.variants[variant_index].variant_options[option_index].name+" ";
                this.variants[variant_index].variant_options[option_index].selected = true;
            },
            removeSelectedVariantOption(variant_index){
                this.variants[variant_index].variant_options.forEach((data, index) => {
                    this.variants[variant_index].variant_options[index].selected = false;
                })
            },
            adjustQuantity(number){
                let quantityPlusDemand = (parseInt(this.quantity) + number);
                if ((quantityPlusDemand> 0 && quantityPlusDemand <= this.stock) || (quantityPlusDemand> 0 && number == -1)){
                    this.quantity = quantityPlusDemand;
                }
            },
            checkVariationSelection(variants){
                let count = 0;
                let selected = []; //id of all option selected
                variants.forEach((variant, index) => {
                    variant.variant_options.forEach((option, index)=>{
                        if(option.selected){
                            count++;
                            selected.push(option.id);
                        }
                    });
                });


                if (count == variants.length){
                    this.checkVariationSelected = true;

                    this.getVariationPrice(selected);
                }

            },
            getVariationPrice(selectedVariant){

                this.variations.forEach((variation) => {
                   let count = 0;
                   variation.variation_options.forEach((option)=>{
                       if(selectedVariant.includes(option.id)){
                           count++;
                       }
                   });


                    if (count == this.variants.length){
                        this.original_price = variation.price;
                        this.price = variation.price;

                        this.variationSelected = variation;
                        this.getVariationStockInSelectedBranch();
                        return variation;
                    }
                });
            },
            getVariationStockInSelectedBranch(){
                this.stock = 0;
                if (this.variationSelected)
                {
                    this.variationSelected.branch_variation.forEach(branch => {
                        if (branch.branch_id == this.selectedBranch.id){
                            this.branch_variation = branch;
                            this.stock = branch.quantity;
                        }
                    });
                }
            },
            addToCart()
            {
                if (this.checkVariationSelected)
                {
                    if (this.stock != 0 && this.quantity != 0)
                    {
                        if (this.stock >= this.quantity)
                        {
                            if (this.$store.state.user != null)
                            {
                                let formData = {};
                                formData.branch             = this.selectedBranch;
                                formData.branchVariation    = this.branch_variation;
                                formData.quantity           = this.quantity;

                                axios.post('/api/cart', formData)
                                .then(res => 
                                {
                                    this.snackbarShow = true;
                                    this.snackbarColor = "success";
                                    this.snackbarText = "Added to cart";
                                    this.$emit('hide');
                                    if(this.actionCart.toLowerCase() === 'Buy Now'.toLowerCase()){
                                        this.$router.replace({path : `/cart?branch_id=${this.selectedBranch.id}`});
                                    }
                                })
                                .catch(error =>
                                {
                                    this.snackbarShow = true;
                                    this.snackbarColor = "error";
                                    this.snackbarText = "error please report to admin";
                                })
                                .finally(()=>
                                {

                                });
                            }
                            else
                            {
                                /* not logged in */
                                this.loginRegisterModalShow = true;

                                let saved_product = {};
                                    saved_product.branch            = this.selectedBranch;
                                    saved_product.branchVariation   = this.branch_variation;
                                    saved_product.quantity          = this.quantity;
                                    saved_product.action            = this.actionCart.toLowerCase();
                                    
                                this.$store.commit('store_saved_product', saved_product);
                            }
                        }
                        else
                        {
                            this.snackbarShow = true;
                            this.snackbarColor = "error";
                            this.snackbarText = "Not Enough stock !";
                        }
                    }
                    else
                    {
                        this.snackbarShow = true;
                        this.snackbarColor = "error";
                        this.snackbarText = "Not Enough stock !";
                    }
                }
                else{
                    this.snackbarShow = true;
                    this.snackbarColor = "error";
                    this.snackbarText = "Please Select Variation";
                }
            },
            setIfProductHasOneVariation(){
                if (this.variants.length == 0){
                    this.variationSelected = this.variations[0];
                    this.checkVariationSelected = true;
                    this.getVariationStockInSelectedBranch();
                }
            },
            defaultSelectedVariant(){
                if (typeof this.variants[0] !== 'undefined'){
                    this.variants[0].variant_options[0].selected = true;
                }

                if (typeof this.variants[1] !== 'undefined'){
                    this.variants[1].variant_options[0].selected = true;
                }
            }
        },
        mounted(){
            this.selectedBranch = this.branches[0];
            this.formatVariantSelection();
            this.defaultSelectedVariant();
            this.checkVariationSelection(this.variants);

            EventBus.$off('addCartOnLogin');
            EventBus.$on('addCartOnLogin', ()=>{
                this.addToCart();
                if(this.actionCart.toLowerCase() == 'add to cart'){
                    this.$router.replace({path : '/'});
                }
            });



            this.setIfProductHasOneVariation();
        },
        destroyed(){
            EventBus.$off('addCartOnLogin');
        }
    }
</script>

<style lang="scss">
    .outline-field {
        .v-input__slot {
            box-shadow: none !important;
            border: 1px solid rgba(#000, .1);
        }
    }
</style>
